import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2942bae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card p-3 mb-4" }
const _hoisted_2 = { class: "row g-2 align-items-end mb-2" }
const _hoisted_3 = { class: "col-lg-3 col-md-4 col-sm-6" }
const _hoisted_4 = { class: "form-label" }
const _hoisted_5 = ["label"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "col-lg-3 col-md-4 col-sm-6" }
const _hoisted_8 = { class: "form-label mb-1" }
const _hoisted_9 = { value: "" }
const _hoisted_10 = { value: "CREATE" }
const _hoisted_11 = { value: "UPDATE" }
const _hoisted_12 = { value: "DELETE" }
const _hoisted_13 = { class: "col-lg-3 col-md-4 col-sm-6" }
const _hoisted_14 = { class: "form-label mb-1" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "col-lg-3 col-md-4 col-sm-6" }
const _hoisted_17 = { class: "form-label" }
const _hoisted_18 = ["label"]
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "col-lg-3 col-md-4 col-sm-6" }
const _hoisted_21 = { class: "form-label mb-1" }
const _hoisted_22 = { class: "col-lg-3 col-md-4 col-sm-6" }
const _hoisted_23 = { class: "form-label mb-1" }
const _hoisted_24 = { class: "col-12 col-md-auto ms-md-auto d-flex justify-content-end gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.translate('entityType')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.entityType) = $event)),
          class: "form-select form-select-sm form-select-solid"
        }, [
          _createElementVNode("option", {
            label: _ctx.translate('selectEntityType'),
            disabled: "",
            value: ""
          }, null, 8, _hoisted_5),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityTypes, (type) => {
            return (_openBlock(), _createElementBlock("option", {
              key: type.value,
              value: type.value
            }, _toDisplayString(type.label), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedItems.entityType]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('action')), 1),
        _withDirectives(_createElementVNode("select", {
          class: "form-select form-select-sm form-select-solid",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems.action) = $event))
        }, [
          _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.translate('all')), 1),
          _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.translate('create')), 1),
          _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.translate('update')), 1),
          _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.translate('delete')), 1)
        ], 512), [
          [_vModelSelect, _ctx.selectedItems.action]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.translate('entityId')), 1),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          name: "entityId",
          class: "form-control form-control-sm form-control-solid",
          placeholder: _ctx.translate('enterEntityId'),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItems.entityId) = $event)),
          onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["enter"]))
        }, null, 40, _hoisted_15), [
          [
            _vModelText,
            _ctx.selectedItems.entityId,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.translate('area')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedItems.areaId) = $event)),
          class: "form-select form-select-sm form-select-solid"
        }, [
          _createElementVNode("option", {
            label: _ctx.translate('selectArea'),
            disabled: "",
            value: ""
          }, null, 8, _hoisted_18),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areas, (area) => {
            return (_openBlock(), _createElementBlock("option", {
              key: area.id,
              value: area.id
            }, _toDisplayString(area.title), 9, _hoisted_19))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedItems.areaId]
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.translate('dateFrom')), 1),
        _withDirectives(_createElementVNode("input", {
          type: "date",
          name: "dateFrom",
          class: "form-select form-select-sm form-select-solid",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedItems.dateFrom) = $event))
        }, null, 512), [
          [_vModelText, _ctx.selectedItems.dateFrom]
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('dateTo')), 1),
        _withDirectives(_createElementVNode("input", {
          type: "date",
          name: "dateTo",
          class: "form-select form-select-sm form-select-solid",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedItems.dateTo) = $event))
        }, null, 512), [
          [_vModelText, _ctx.selectedItems.dateTo]
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("button", {
          class: "btn btn-light",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
        }, _toDisplayString(_ctx.translate('reset')), 1),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, _toDisplayString(_ctx.translate('apply')), 1)
      ])
    ])
  ]))
}